import React, { useEffect } from 'react';
import { api } from '../../lib/api';
import { useApp } from '../../context/AppContext';
import { Button } from '../ui/button';
import { ExternalLink } from 'lucide-react';

export default function SponsoredCard({ ad, compact = false }) {
  const { t } = useApp();

  useEffect(() => {
    if (ad?.id) api.post(`/ads/${ad.id}/impression`).catch(() => {});
  }, [ad?.id]);

  const onClick = () => api.post(`/ads/${ad.id}/click`).catch(() => {});

  if (!ad) return null;

  return (
    <div className="bg-card rounded-xl border border-border overflow-hidden elev-1" data-testid="sponsored-card">
      <div className="flex items-center justify-between px-4 py-2.5">
        <span className="text-xs font-semibold">{ad.sponsor}</span>
        <span data-testid="post-sponsored-label" className="text-[10px] uppercase tracking-wider text-muted-foreground border border-border rounded-full px-2 py-0.5">
          {t('sponsored')}
        </span>
      </div>
      {!compact && <img src={ad.image} alt={ad.title} className="w-full h-44 object-cover" loading="lazy" />}
      <div className="p-4">
        <h4 className="text-sm font-semibold">{ad.title}</h4>
        <p className="text-xs text-muted-foreground mt-1">{ad.description}</p>
        <Button data-testid="sponsored-card-cta-button" size="sm" variant="outline" onClick={onClick} className="mt-3 w-full border-primary/40 text-primary hover:bg-primary/10">
          {ad.cta} <ExternalLink size={13} className="ms-1.5" />
        </Button>
      </div>
    </div>
  );
}
